import HeaderCell from './HeaderCell';

export default HeaderCell;
